export default __webpack_public_path__ + "static/media/frame.da4a065b.png";